import { getFamilyDisplayName, normalizeFamilyUnitNo } from "@/lib/family-units";

type FamilyMember = {
  familyUnitNo?: string;
  familyName?: string;
  isFamilyHead?: boolean;
};

export type DuplicateFamilyHeadIssue = {
  familyUnitNo: string;
  familyName: string;
  memberIndexes: number[];
  message: string;
};

export function getDuplicateFamilyHeadIssues(members: readonly FamilyMember[]) {
  const headsByFamily = new Map<string, number[]>();

  members.forEach((member, index) => {
    if (!member.isFamilyHead) {
      return;
    }

    const familyUnitNo = normalizeFamilyUnitNo(member.familyUnitNo);
    headsByFamily.set(familyUnitNo, [...(headsByFamily.get(familyUnitNo) ?? []), index]);
  });

  return [...headsByFamily.entries()].flatMap(([familyUnitNo, memberIndexes]) => {
    if (memberIndexes.length < 2) {
      return [];
    }

    const firstMember = members[memberIndexes[0]];
    const familyName = getFamilyDisplayName(familyUnitNo, firstMember?.familyName);

    return [{
      familyUnitNo,
      familyName,
      memberIndexes,
      message: `Only one family head is allowed for ${familyName}.`,
    }];
  });
}
